import { render, staticRenderFns } from "./ChartPanel.vue?vue&type=template&id=2f36bb9e&scoped=true&"
import script from "./ChartPanel.vue?vue&type=script&lang=js&"
export * from "./ChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChartPanel.vue?vue&type=style&index=0&id=2f36bb9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f36bb9e",
  null
  
)

export default component.exports